{{#if (and isComponent (not virtual))}}
{{> (partial "snippets/uvm-component-utils")}}

{{else if (and isObject (not virtual))}}
{{> (partial "snippets/uvm-object-utils")}}

{{/if}}
